module.exports = __webpack_public_path__ + "static/media/group.7e8b583b.svg";